import { cn } from "@newxsystems/shared";
import { DaylightCardLink } from "../DaylightCardLink/DaylightCardLink";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { IImageContentGridTopProps } from "./ImageContentGridTop.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridTop = ({
  columnCount,
  headingAs = "h3",
  imageAspectRatio,
  items,
}: IImageContentGridTopProps) => {
  const Heading = headingAs;
  return (
    <div
      className={cn("grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2", columns[columnCount || 3])}
      data-reveal="stagger"
    >
      {items.map((item, index) => (
        <DaylightCardLink className="group/card flex flex-col" key={index} link={item.cardLink}>
          <DaylightMedia
            aspectRatio={imageAspectRatio || "16:9"}
            imageClassName="transition-transform duration-[600ms] ease-out group-hover/card:scale-[1.04]"
            media={item.image.image}
            effect={item.image.effect}
            sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          />
          <div className="mt-5 flex flex-1 flex-col gap-3 border-t border-border pt-5">
            <div className="flex items-center justify-between gap-4">
              <span className="signal-numeric text-xs text-primary">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span
                aria-hidden="true"
                className="font-daylight-body text-base leading-none text-ash transition-[transform,color] duration-200 ease-out group-hover/card:translate-x-1 group-hover/card:text-primary"
              >
                →
              </span>
            </div>
            <Heading className="max-w-[20ch] font-daylight-display text-xl font-semibold leading-[1.15] tracking-[-0.02em] text-foreground transition-colors duration-200 group-hover/card:text-primary md:text-2xl">
              {item.heading}
            </Heading>
            {item.description ? (
              <DaylightRichText
                className="max-w-[42ch] text-base text-ash"
                content={item.description}
              />
            ) : null}
            {item.cardLink?.label ? (
              <span className="signal-label mt-1 text-primary">{item.cardLink.label}</span>
            ) : null}
          </div>
        </DaylightCardLink>
      ))}
    </div>
  );
};

ImageContentGridTop.displayName = "Content::ImageContentGridTop";
